import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { aiApi } from '@/utils/aiApi';

// Scheduled reminders of the signed-in user (list, add, cancel).
export const useReminders = () => {
  const [reminders, setReminders] = useState([]);

  const refresh = useCallback(() => aiApi.reminders().then(setReminders).catch(() => {}), []);
  useEffect(() => { refresh(); }, [refresh]);

  const add = useCallback((reminder) => {
    setReminders((prev) => [...prev, reminder].sort((a, b) => a.due_at.localeCompare(b.due_at)));
  }, []);

  const cancel = useCallback(async (id) => {
    try {
      await aiApi.cancelReminder(id);
      setReminders((prev) => prev.filter((r) => r.id !== id));
      toast.success('Reminder cancelled');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not cancel the reminder');
    }
  }, []);

  return { reminders, refresh, add, cancel };
};
